module.exports = __webpack_public_path__ + "static/media/motomuto.59a7b03e.svg";